import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from 'components/Utils/IconButton'
import { CloseIcon } from 'components/Utils/Icons'
import { Text } from 'components/base'

import { Link } from 'react-router-dom'
import * as tabTypes from './tabTypes'
import InAppNotFound from 'components/Errors/InAppNotFound'

class Header extends Component {
  static propTypes = {
    returnTo: PropTypes.string.isRequired,
    tab: PropTypes.string,
    type: PropTypes.string,
  }

  render() {
    const tab = !this.props.tab
      ? tabTypes.INFORMATIONS
      : tabTypes[
          // eslint-disable-next-line import/namespace
          Object.keys(tabTypes).find(obj => tabTypes[obj].id === this.props.tab)
        ]

    if (!tab) {
      return <InAppNotFound />
    }
    return (
      <div className="flexbox-no-shrink flexbox-space-between flexbox flexbox-align-center width-full padding-large border-bottom-medium border-shade-50">
        <Text.Title>{tab.title}</Text.Title>
        <Link to={this.props.returnTo}>
          <IconButton>
            <CloseIcon size={16} />
          </IconButton>
        </Link>
      </div>
    )
  }
}

export default Header
